import "@crystal/core";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import { getAccountPortalState } from "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "@crystal/analytics";
import "../ap2/config.js";
import "../ap2/state.js";
import "../external-auth/config.js";
import "@crystal/config";
import "../config/source-ids.js";
import { Touchpoint } from "../config/touchpoints.js";
import "../config/presets.js";
function getRuntimeInfo() {
  const state = getAccountPortalState();
  return {
    isModalVisible: state == null ? void 0 : state.isModalVisible,
    pageContext: state == null ? void 0 : state.pageContext,
    preset: state == null ? void 0 : state.preset,
    touchpoint: state == null ? void 0 : state.touchpoint,
    hasModalClient: state == null ? void 0 : state.hasModalClient,
    isAccountPortalEnabled: state == null ? void 0 : state.isAccountPortalEnabled,
    mfId: state == null ? void 0 : state.mfId,
    isAuthProvider: state == null ? void 0 : state.isAuthProvider,
    propSourceId: state == null ? void 0 : state.propSourceId,
    storeId: state == null ? void 0 : state.storeId,
    hintAcid: state == null ? void 0 : state.hintAcid
  };
}
function getAuthentication() {
  const {
    user,
    status,
    error,
    isAuthenticated,
    isPersistent,
    eventType,
    authContext,
    isSessionReload,
    isReauthenticated
  } = getAccountPortalState() || {};
  let isUserBlocked = false;
  let isTemporarilyLocked = false;
  if (eventType === "login" && status === "error") {
    const err = error;
    isUserBlocked = !!err.isUserBlocked;
    isTemporarilyLocked = !!err.isTemporarilyLocked;
  }
  return {
    user,
    error,
    isAuthenticated,
    isSessionReload,
    isReauthenticated,
    isPersistent,
    authContext,
    errorDetails: {
      isUserBlocked,
      isTemporarilyLocked
    },
    isPending: (authContext == null ? void 0 : authContext.hasUser) && status === "pending",
    isExternalAuth: eventType === "externalAuth"
  };
}
const getTouchpointName = () => {
  return getRuntimeInfo().touchpoint || Touchpoint.Unknown;
};
export {
  getAuthentication,
  getRuntimeInfo,
  getTouchpointName
};
//# sourceMappingURL=state-getters.js.map
